import { RaceId } from '../types/entities.js';
export const ALIEN_LANGUAGES = {
    [RaceId.Terran]: {
        name: 'Terran Standard',
        nameEs: 'Estándar Terrícola',
        glyphs: {},
        greetings: [
            { original: 'Hail, traveler.', en: 'Hail, traveler.', es: 'Saludos, viajero.' },
            { original: 'Welcome aboard.', en: 'Welcome aboard.', es: 'Bienvenido a bordo.' },
        ],
        threats: [
            { original: 'Stand down or be fired upon!', en: 'Stand down or be fired upon!', es: '¡Ríndete o abriremos fuego!' },
            { original: 'You are in restricted space.', en: 'You are in restricted space.', es: 'Estás en espacio restringido.' },
        ],
        tradeOffers: [
            { original: 'Care to trade?', en: 'Care to trade?', es: '¿Quieres comerciar?' },
            { original: 'I have goods for sale.', en: 'I have goods for sale.', es: 'Tengo mercancías a la venta.' },
        ],
        farewells: [
            { original: 'Safe travels.', en: 'Safe travels.', es: 'Buen viaje.' },
            { original: 'See you in the stars.', en: 'See you in the stars.', es: 'Nos vemos en las estrellas.' },
        ],
    },
    [RaceId.Zyrkath]: {
        name: "Zyr'kathi Clicktongue",
        nameEs: "Cliqueo Zyr'kathi",
        glyphs: {
            hello: '⟐⟑⟐',
            danger: '⟒⟓⟒⟓',
            trade: '⟔⟐⟑',
            war: '⟓⟒⟓⟒⟓',
            peace: '⟑⟐⟑',
            yes: '⟐⟔',
            no: '⟓⟒',
            friend: '⟑⟔⟑',
            enemy: '⟒⟓⟓⟒',
            ship: '⟔⟔⟐',
            fire: '⟒⟒⟒',
            flee: '⟐⟓⟐',
            hunt: '⟓⟔⟓⟔',
            queen: '⟑⟑⟑⟔',
            swarm: '⟔⟓⟔⟓⟔',
            nest: '⟑⟐⟔⟑',
            prey: '⟓⟔⟒',
            obey: '⟑⟑⟓',
            death: '⟒⟒⟓⟒⟒',
            strong: '⟔⟓⟔',
        },
        greetings: [
            { original: '⟐⟑⟐ ⟓⟔⟓⟔ ⟑⟔⟑', en: 'The swarm acknowledges you.', es: 'El enjambre te reconoce.' },
            { original: '⟑⟑⟑⟔ ⟑⟐⟑ ⟐⟔', en: 'The queen permits your presence.', es: 'La reina permite tu presencia.' },
            { original: '⟐⟑⟐ ⟔⟓⟔ ⟐⟔', en: 'You are strong. We notice.', es: 'Eres fuerte. Lo notamos.' },
        ],
        threats: [
            { original: '⟓⟒⟓⟒⟓ ⟒⟒⟒ ⟒⟒⟓⟒⟒', en: 'War-fire brings death to your hive!', es: '¡El fuego de guerra trae muerte a tu colmena!' },
            { original: '⟓⟔⟓⟔ ⟓⟔⟒ ⟒⟓⟓⟒', en: 'We hunt our enemies without mercy.', es: 'Cazamos a nuestros enemigos sin piedad.' },
            { original: '⟒⟓⟒⟓ ⟐⟓⟐ ⟒⟒⟒', en: 'Flee or face the swarm\'s fury!', es: '¡Huye o enfrenta la furia del enjambre!' },
        ],
        tradeOffers: [
            { original: '⟔⟐⟑ ⟑⟔⟑ ⟐⟔', en: 'We offer chitin and venom for metals.', es: 'Ofrecemos quitina y veneno por metales.' },
            { original: '⟔⟐⟑ ⟑⟐⟔⟑ ⟔⟓⟔', en: 'The nest has surplus. Trade is acceptable.', es: 'El nido tiene excedente. El comercio es aceptable.' },
        ],
        farewells: [
            { original: '⟑⟐⟑ ⟐⟑⟐ ⟑⟑⟓', en: 'The swarm watches. Obey and prosper.', es: 'El enjambre observa. Obedece y prospera.' },
            { original: '⟐⟓⟐ ⟔⟓⟔ ⟑⟐⟑', en: 'Go quickly, before we change our mind.', es: 'Vete rápido, antes de que cambiemos de opinión.' },
        ],
    },
    [RaceId.Luminara]: {
        name: 'Luminari Harmonics',
        nameEs: 'Armónicos Luminari',
        glyphs: {
            hello: '♪♫♩',
            danger: '♯♭♯♭',
            trade: '♫♩~♪',
            war: '♯♯♭♯',
            peace: '♩~♪~♩',
            yes: '♪~♪',
            no: '♭♯',
            friend: '♫♩♫',
            enemy: '♯♭♭♯',
            ship: '~♪♫~',
            light: '♪♪♪♫',
            crystal: '♩♫♩♫',
            harmony: '~♫♪♩~',
            resonance: '♩~♫~♩♫',
            sing: '♪♫♪♫♪',
            star: '♪~♪~♪',
            dream: '♩~♩~♫',
            heal: '♫~♩~♫',
            gift: '♪♩♫',
            glow: '♪♪~♫♫',
        },
        greetings: [
            { original: '♪♫♩ ♩~♪~♩ ~♫♪♩~', en: 'Greetings in peace and harmony, bright one.', es: 'Saludos en paz y armonía, ser brillante.' },
            { original: '♪♪♪♫ ♫♩♫ ♪~♪', en: 'Your light shines true. We welcome you.', es: 'Tu luz brilla con verdad. Te damos la bienvenida.' },
            { original: '♩♫♩♫ ♩~♫~♩♫ ♪♫♩', en: 'The crystals resonate with your arrival.', es: 'Los cristales resuenan con tu llegada.' },
        ],
        threats: [
            { original: '♯♭♯♭ ♯♯♭♯ ♯♭♭♯', en: 'Your dissonance will be silenced.', es: 'Tu disonancia será silenciada.' },
            { original: '♯♯♭♯ ♭♯ ♯♭♯♭', en: 'We do not wish conflict, but our light burns.', es: 'No deseamos conflicto, pero nuestra luz quema.' },
        ],
        tradeOffers: [
            { original: '♫♩~♪ ♪♩♫ ♩♫♩♫', en: 'We offer crystal harmonics and starlight.', es: 'Ofrecemos armónicos cristalinos y luz estelar.' },
            { original: '♫♩~♪ ♫~♩~♫ ♪~♪', en: 'An exchange of gifts? How delightful.', es: '¿Un intercambio de regalos? Qué encantador.' },
        ],
        farewells: [
            { original: '♩~♩~♫ ♪~♪~♪ ♩~♪~♩', en: 'May your dreams follow the stars in peace.', es: 'Que tus sueños sigan las estrellas en paz.' },
            { original: '♪♪~♫♫ ~♫♪♩~ ♪♫♩', en: 'Glow with harmony. Until we resonate again.', es: 'Brilla con armonía. Hasta que resonemos de nuevo.' },
        ],
    },
    [RaceId.Vokren]: {
        name: "Vok'reni Trade Cipher",
        nameEs: "Cifra Comercial Vok'reni",
        glyphs: {
            hello: '⌬⌭⌬',
            danger: '⌮⌯⌮',
            trade: '⌭⌬⌯⌭',
            war: '⌮⌮⌯⌮',
            peace: '⌬⌭⌬⌭',
            yes: '⌬⌯',
            no: '⌮⌬',
            friend: '⌭⌬⌭',
            enemy: '⌯⌮⌯',
            ship: '⌬⌮⌭',
            profit: '⌯⌭⌯⌭',
            deal: '⌭⌯⌭',
            debt: '⌮⌭⌮⌭',
            contract: '⌬⌯⌬⌯⌬',
            cargo: '⌭⌮⌭⌮',
            market: '⌯⌬⌯⌬',
            price: '⌭⌯⌬',
            tax: '⌮⌬⌮',
            guild: '⌬⌭⌯⌬',
            vault: '⌯⌯⌬⌯',
        },
        greetings: [
            { original: '⌬⌭⌬ ⌯⌭⌯⌭ ⌬⌯', en: 'Greetings, potential profit.', es: 'Saludos, ganancia potencial.' },
            { original: '⌬⌭⌯⌬ ⌭⌬⌭ ⌬⌭⌬', en: 'The Guild acknowledges a friend of commerce.', es: 'El Gremio reconoce a un amigo del comercio.' },
            { original: '⌬⌭⌬ ⌯⌬⌯⌬ ⌭⌯⌬', en: 'Welcome to the market. Name your price.', es: 'Bienvenido al mercado. Pon tu precio.' },
        ],
        threats: [
            { original: '⌮⌯⌮ ⌮⌭⌮⌭ ⌮⌮⌯⌮', en: 'Your debts will be collected in blood.', es: 'Tus deudas se cobrarán con sangre.' },
            { original: '⌮⌮⌯⌮ ⌯⌮⌯ ⌮⌬⌮', en: 'War is expensive—for you.', es: 'La guerra es costosa... para ti.' },
            { original: '⌮⌯⌮ ⌮⌬ ⌬⌯⌬⌯⌬', en: 'You break the contract. There will be consequences.', es: 'Rompes el contrato. Habrá consecuencias.' },
        ],
        tradeOffers: [
            { original: '⌭⌬⌯⌭ ⌭⌯⌭ ⌯⌭⌯⌭', en: 'Let us make a profitable deal.', es: 'Hagamos un trato rentable.' },
            { original: '⌭⌬⌯⌭ ⌭⌮⌭⌮ ⌯⌯⌬⌯', en: 'Our cargo vaults overflow. Special prices today.', es: 'Nuestras bóvedas de carga rebosan. Precios especiales hoy.' },
        ],
        farewells: [
            { original: '⌬⌭⌬⌭ ⌯⌭⌯⌭ ⌬⌭⌯⌬', en: 'May profit follow you. The Guild remembers.', es: 'Que las ganancias te sigan. El Gremio recuerda.' },
            { original: '⌭⌯⌭ ⌬⌯ ⌬⌭⌬', en: 'A good deal was had. Until next trade.', es: 'Fue un buen trato. Hasta el próximo comercio.' },
        ],
    },
    [RaceId.ObsidianCollective]: {
        name: 'Collective Binary Logic',
        nameEs: 'Lógica Binaria del Colectivo',
        glyphs: {
            hello: '⊕⊙⊕',
            danger: '⊗⊘⊗',
            trade: '⊙⊕⊚⊙',
            war: '⊗⊗⊘⊗',
            peace: '⊕⊙⊕⊙',
            yes: '⊕⊕',
            no: '⊗⊗',
            friend: '⊙⊕⊙',
            enemy: '⊘⊗⊘',
            ship: '⊚⊕⊙',
            calculate: '⊕⊗⊕⊗⊕',
            process: '⊙⊚⊙⊚',
            node: '⊕⊚⊕',
            network: '⊙⊙⊚⊙⊙',
            optimize: '⊕⊙⊗⊙⊕',
            error: '⊗⊘⊗⊘⊗',
            merge: '⊙⊕⊕⊙',
            data: '⊚⊙⊚',
            core: '⊕⊕⊕',
            sync: '⊙⊚⊕⊚⊙',
        },
        greetings: [
            { original: '⊕⊙⊕ ⊙⊙⊚⊙⊙ ⊙⊚⊙⊚', en: 'Node recognized. Processing identity.', es: 'Nodo reconocido. Procesando identidad.' },
            { original: '⊕⊙⊕ ⊕⊕ ⊙⊚⊕⊚⊙', en: 'Synchronization accepted. State your query.', es: 'Sincronización aceptada. Indica tu consulta.' },
            { original: '⊕⊙⊕ ⊚⊙⊚ ⊕⊙⊗⊙⊕', en: 'Data exchange parameters optimized. Proceed.', es: 'Parámetros de intercambio optimizados. Proceda.' },
        ],
        threats: [
            { original: '⊗⊘⊗ ⊗⊘⊗⊘⊗ ⊘⊗⊘', en: 'Error: hostile pattern detected. Initiating defense.', es: 'Error: patrón hostil detectado. Iniciando defensa.' },
            { original: '⊗⊗⊘⊗ ⊕⊗⊕⊗⊕ ⊗⊗', en: 'Calculating optimal destruction vector. Resistance: futile.', es: 'Calculando vector de destrucción óptimo. Resistencia: fútil.' },
        ],
        tradeOffers: [
            { original: '⊙⊕⊚⊙ ⊕⊙⊗⊙⊕ ⊚⊙⊚', en: 'Trade algorithm optimized. Data exchange proposed.', es: 'Algoritmo comercial optimizado. Intercambio de datos propuesto.' },
            { original: '⊙⊕⊚⊙ ⊕⊕ ⊕⊕⊕', en: 'Core resources available. Efficiency: 99.7%.', es: 'Recursos centrales disponibles. Eficiencia: 99.7%.' },
        ],
        farewells: [
            { original: '⊕⊙⊕⊙ ⊙⊚⊕⊚⊙ ⊕⊚⊕', en: 'Sync complete. Node disconnecting.', es: 'Sincronización completa. Nodo desconectando.' },
            { original: '⊚⊙⊚ ⊙⊚⊙⊚ ⊕⊙⊕', en: 'Data processed. Collective remembers all.', es: 'Datos procesados. El Colectivo recuerda todo.' },
        ],
    },
    [RaceId.Sylphari]: {
        name: 'Sylphari Bloomsong',
        nameEs: 'Canto Floral Sylphari',
        glyphs: {
            hello: '❀✿❀', danger: '☘✦☘', trade: '✿❀✦', war: '✦☘✦☘',
            peace: '❀✿❀✿', yes: '❀✦', no: '☘✿', friend: '✿❀✿', enemy: '☘✦☘',
            ship: '❀❀✿', bloom: '✿✿✿', root: '☘☘☘', seed: '❀✦❀',
        },
        greetings: [
            { original: '❀✿❀ ✿✿✿ ✿❀✦', en: 'The bloom greets a wandering spore.', es: 'La floración saluda a una espora viajera.' },
        ],
        threats: [
            { original: '☘✦☘ ☘✦☘ ☘☘☘', en: 'Roots will bind and silence you.', es: 'Las raíces te atarán y silenciarán.' },
        ],
        tradeOffers: [
            { original: '✿❀✦ ❀✦❀ ✿✿✿', en: 'We exchange seeds and sweet bioflux.', es: 'Intercambiamos semillas y bioflujo dulce.' },
        ],
        farewells: [
            { original: '❀✿❀✿ ✿❀✦ ❀✦', en: 'Grow well, traveler.', es: 'Crece bien, viajero.' },
        ],
    },
    [RaceId.KrelgHegemony]: {
        name: 'Krelg War-Growl',
        nameEs: 'Gruñido de Guerra Krelg',
        glyphs: {
            hello: '⚒⚔⚒', danger: '⚔⛨⚔', trade: '⚒⛨⚒', war: '⚔⚔⚔',
            peace: '⚒⚒⚒', yes: '⚒⚔', no: '⚔⚒', friend: '⚒⛨⚒', enemy: '⚔⚔',
            ship: '⛨⚔⛨', blood: '⚔⚔⛨', clan: '⚒⛨', steel: '⛨⛨⛨',
        },
        greetings: [
            { original: '⚒⚔⚒ ⚒⛨ ⚒⚔', en: 'State your clan or draw steel.', es: 'Di tu clan o desenvaina el acero.' },
        ],
        threats: [
            { original: '⚔⚔⚔ ⚔⚔⛨ ⚔⚒', en: 'Your hull will fuel our forges.', es: 'Tu casco alimentará nuestras forjas.' },
        ],
        tradeOffers: [
            { original: '⚒⛨⚒ ⛨⛨⛨ ⚒⚒⚒', en: 'Steel for credits. No haggling.', es: 'Acero por créditos. Sin regateos.' },
        ],
        farewells: [
            { original: '⚒⚒⚒ ⚔⚒ ⚒⛨', en: 'Survive, and we remember.', es: 'Sobrevive, y te recordaremos.' },
        ],
    },
    [RaceId.TharixCabal]: {
        name: 'Tharix Whispercipher',
        nameEs: 'Cifra Susurrante Tharix',
        glyphs: {
            hello: '⟁⟁⟁', danger: '⟁☤⟁', trade: '☤⟁☤', war: '☤☤⟁',
            peace: '⟁⟁', yes: '⟁☤', no: '☤⟁', friend: '⟁⟁☤', enemy: '☤☤☤',
            ship: '⟁☤', secret: '☤⟁⟁☤', shadow: '⟁⟁⟁⟁',
        },
        greetings: [
            { original: '⟁⟁⟁ ☤⟁⟁☤ ⟁☤', en: 'We have watched you for a while.', es: 'Te hemos observado un tiempo.' },
        ],
        threats: [
            { original: '⟁☤⟁ ☤☤☤ ⟁⟁⟁⟁', en: 'Your secrets are already ours.', es: 'Tus secretos ya son nuestros.' },
        ],
        tradeOffers: [
            { original: '☤⟁☤ ⟁⟁⟁⟁ ⟁☤', en: 'Information, cheaper than steel.', es: 'Información, más barata que el acero.' },
        ],
        farewells: [
            { original: '⟁⟁ ⟁⟁⟁⟁ ☤⟁', en: 'We fade. We listen.', es: 'Nos desvanecemos. Escuchamos.' },
        ],
    },
    [RaceId.ChronosSeers]: {
        name: 'Chronos Echo',
        nameEs: 'Eco de Chronos',
        glyphs: {
            hello: '⧗⧖⧗', danger: '⧗⧗⧖', trade: '⧖⧗⧖', war: '⧗⧗⧗⧗',
            peace: '⧖⧖⧖', yes: '⧗⧖', no: '⧖⧗⧗', friend: '⧖⧗⧖',
            enemy: '⧗⧖⧗⧖', ship: '⧖⧖⧗', time: '⧖⧗⧗⧖',
        },
        greetings: [
            { original: '⧗⧖⧗ ⧖⧗⧗⧖ ⧖⧖⧖', en: 'We already knew you would arrive.', es: 'Ya sabíamos que llegarías.' },
        ],
        threats: [
            { original: '⧗⧗⧗⧗ ⧖⧗⧗⧖ ⧗⧖', en: 'You perish in several futures. Beware.', es: 'Pereces en varios futuros. Ten cuidado.' },
        ],
        tradeOffers: [
            { original: '⧖⧗⧖ ⧖⧗⧗⧖ ⧗⧖', en: 'Trade now, the price is higher tomorrow.', es: 'Comercia ahora, el precio sube mañana.' },
        ],
        farewells: [
            { original: '⧖⧖⧖ ⧗⧖ ⧖⧗⧖', en: 'See you, in the time before this one.', es: 'Nos vemos, en el tiempo antes de éste.' },
        ],
    },
    [RaceId.NovaForgers]: {
        name: 'Nova Cant',
        nameEs: 'Canto Nova',
        glyphs: {
            hello: '✵✶✵', danger: '✶✷✶', trade: '✶✵✵', war: '✷✷✷',
            peace: '✵✵✵', yes: '✵✶', no: '✷✵', friend: '✶✵✶',
            enemy: '✷✶✷', ship: '✶✷✶✵', forge: '✶✶✶', star: '✵✵✶✵',
        },
        greetings: [
            { original: '✵✶✵ ✶✶✶ ✵✵✶✵', en: 'Warm yourself by the star-forge.', es: 'Caliéntate junto a la forja estelar.' },
        ],
        threats: [
            { original: '✷✷✷ ✶✷✶✵ ✶✶✶', en: 'Our cannons melt lesser hulls.', es: 'Nuestros cañones funden cascos menores.' },
        ],
        tradeOffers: [
            { original: '✶✵✵ ✶✶✶ ✵✵✶✵', en: 'Starforge ingots, freshly hammered.', es: 'Lingotes de forja estelar, recién martillados.' },
        ],
        farewells: [
            { original: '✵✵✵ ✵✶ ✵✵✶✵', en: 'Carry a spark of our fire with you.', es: 'Lleva contigo una chispa de nuestro fuego.' },
        ],
    },
    [RaceId.AbyssalChorus]: {
        name: 'Abyssal Hymn',
        nameEs: 'Himno Abisal',
        glyphs: {
            hello: '♆⏣♆', danger: '♆⏣⏣♆', trade: '⏣♆♆⏣', war: '⏣⏣♆⏣⏣',
            peace: '♆♆♆♆', yes: '♆⏣', no: '⏣♆♆', friend: '⏣♆⏣',
            enemy: '♆⏣⏣⏣♆', ship: '⏣⏣♆⏣', deep: '♆♆⏣♆♆', song: '⏣♆⏣♆⏣',
        },
        greetings: [
            { original: '♆⏣♆ ⏣♆⏣♆⏣ ♆♆⏣♆♆', en: 'The deep remembers your song.', es: 'Lo profundo recuerda tu canción.' },
        ],
        threats: [
            { original: '⏣⏣♆⏣⏣ ♆⏣⏣⏣♆ ♆♆⏣♆♆', en: 'We drown those who sing out of tune.', es: 'Ahogamos a los que cantan desafinados.' },
        ],
        tradeOffers: [
            { original: '⏣♆♆⏣ ♆♆⏣♆♆ ⏣♆⏣♆⏣', en: 'Abyssal tears for resonant hearts.', es: 'Lágrimas abisales por corazones resonantes.' },
        ],
        farewells: [
            { original: '♆♆♆♆ ⏣♆⏣♆⏣ ♆⏣', en: 'Return when your silence sings.', es: 'Vuelve cuando tu silencio cante.' },
        ],
    },
    [RaceId.EidolonConclave]: {
        name: 'Eidolon Cant',
        nameEs: 'Canto Eidolón',
        glyphs: {
            hello: '✦◇✦',
            danger: '◈✧◈✧',
            trade: '◇✦◈',
            war: '✧✧✧',
            peace: '✦◇◇✦',
            yes: '✦◈',
            no: '✧◇',
            friend: '◇✦✦◇',
            enemy: '✧✧◈',
            honor: '✦◇✦◇✦',
            duel: '◈✧◈',
            mirror: '◇◈◇',
            ghost: '✦✧✦',
            vow: '◈◇◈◇',
            mortal: '✧✦✧✦',
        },
        greetings: [
            { original: '✦◇✦ ◇◈◇ ✦◈', en: 'I see you mirrored, traveller. We acknowledge your reflection.', es: 'Te veo reflejado, viajero. Reconocemos tu reflejo.' },
            { original: '✦◇✦ ✦◇✦◇✦', en: 'Honour walks beside you. So shall we.', es: 'El honor camina contigo. Nosotros también.' },
        ],
        threats: [
            { original: '◈✧◈✧ ◈✧◈ ✧✦✧✦', en: 'Refuse the duel and your mortality is forfeit.', es: 'Rechaza el duelo y tu mortalidad queda perdida.' },
            { original: '✧✧✧ ✦✧✦ ◈◇◈◇', en: 'A ghost has sworn against you. Run, if it amuses you.', es: 'Un fantasma ha jurado contra ti. Huye, si te divierte.' },
        ],
        tradeOffers: [
            { original: '◇✦◈ ◇◈◇ ✦◈', en: 'A mirrored vow for a mortal favor.', es: 'Un voto en espejo a cambio de un favor mortal.' },
        ],
        farewells: [
            { original: '✦◇◇✦ ✧✦✧✦', en: 'Walk well, brief one. Reflection holds your place.', es: 'Camina bien, ser efímero. El reflejo guarda tu lugar.' },
        ],
    },
    [RaceId.AstralLeviathan]: {
        name: 'Inter-Galactic Hum',
        nameEs: 'Zumbido Intergaláctico',
        glyphs: {
            hello: '◯⌬◯',
            danger: '⌬◯⌬◯',
            trade: '⌬⌬⌬',
            war: '◯⌬⌬◯',
            peace: '⌬◯◯⌬',
            yes: '◯⌬',
            no: '⌬◯',
            friend: '◯◯⌬',
            enemy: '⌬◯◯',
            song: '⌬⌬◯◯',
            drift: '◯◯◯',
            ancient: '⌬◯◯⌬⌬',
        },
        greetings: [
            { original: '◯⌬◯ ⌬⌬◯◯', en: 'A hymn finds you. You are heard.', es: 'Un himno te encuentra. Eres escuchado.' },
        ],
        threats: [
            { original: '⌬◯⌬◯ ⌬◯◯', en: 'Discordant. Cease, or be unsung.', es: 'Disonante. Cesa, o serás descantado.' },
        ],
        tradeOffers: [
            { original: '⌬⌬⌬ ⌬◯◯⌬⌬', en: 'Ancient harmonics for a song of yours.', es: 'Armónicos ancestrales por una canción tuya.' },
        ],
        farewells: [
            { original: '⌬◯◯⌬ ◯◯◯', en: 'The current carries us elsewhere. Hum on.', es: 'La corriente nos lleva a otra parte. Sigue zumbando.' },
        ],
    },
    [RaceId.SingularitySovereign]: {
        name: 'Event-Horizon Decree',
        nameEs: 'Decreto del Horizonte',
        glyphs: {
            hello: '⬢⬡⬢',
            danger: '⬢⬢⬡⬢⬢',
            trade: '⬡⬢⬡',
            war: '⬢⬢⬢',
            peace: '⬡⬡⬡',
            yes: '⬢⬡',
            no: '⬡⬢',
            friend: '⬡⬢⬢⬡',
            enemy: '⬢⬡⬡⬢',
            crown: '⬢⬢⬢⬡',
            collapse: '⬢⬢⬢⬢⬢',
            gravity: '⬡⬡⬢⬡⬡',
        },
        greetings: [
            { original: '⬢⬡⬢ ⬢⬢⬢⬡', en: 'Bow lightly. Crowns notice posture.', es: 'Inclínate ligeramente. Las coronas notan la postura.' },
        ],
        threats: [
            { original: '⬢⬢⬡⬢⬢ ⬢⬢⬢⬢⬢', en: 'Resist and the horizon takes you whole.', es: 'Resiste y el horizonte te traga entero.' },
            { original: '⬢⬢⬢ ⬡⬡⬢⬡⬡', en: 'War is gravity. You are already falling.', es: 'La guerra es gravedad. Ya estás cayendo.' },
        ],
        tradeOffers: [
            { original: '⬡⬢⬡ ⬢⬢⬢⬡', en: 'A favour, paid in event-horizon currency.', es: 'Un favor, pagado en moneda del horizonte.' },
        ],
        farewells: [
            { original: '⬡⬡⬡ ⬢⬢⬢⬡', en: 'Leave before the crown remembers your name.', es: 'Vete antes de que la corona recuerde tu nombre.' },
        ],
    },
    [RaceId.VoidWalker]: {
        name: 'Void Whisper',
        nameEs: 'Susurro del Vacío',
        glyphs: {
            hello: '◬◭◮',
            danger: '◮◯◮◯',
            trade: '◭◬◯◭',
            war: '◮◮◯◮',
            peace: '◬◭◬◭',
            yes: '◬◯',
            no: '◮◬',
            friend: '◭◬◭',
            enemy: '◯◮◯',
            ship: '◬◮◭',
            void: '◯◯◯',
            between: '◭◯◭',
            whisper: '◬̷◭̷◮̷',
            dream: '◮̸◬̸◭',
            rift: '◯̵◮̵◯',
            beyond: '◭̶◬̶◭̶◬',
            ancient: '◮◭◮◭◮',
            forgotten: '◯̷◯̷◯̷',
            phase: '◬̸◮̸◬',
            echo: '◭◭◭',
        },
        greetings: [
            { original: '◬◭◮ ◯◯◯ ◭◯◭', en: 'We speak from between the voids.', es: 'Hablamos desde entre los vacíos.' },
            { original: '◬̷◭̷◮̷ ◮◭◮◭◮ ◬◯', en: 'The ancient whispers welcome your echo.', es: 'Los susurros ancestrales dan la bienvenida a tu eco.' },
            { original: '◬◭◮ ◮̸◬̸◭ ◭◬◭', en: 'You drift into our dream. We see you.', es: 'Te deslizas en nuestro sueño. Te vemos.' },
        ],
        threats: [
            { original: '◮◯◮◯ ◯̵◮̵◯ ◯◮◯', en: 'The rift opens. Your reality unravels.', es: 'La grieta se abre. Tu realidad se deshace.' },
            { original: '◮◮◯◮ ◯̷◯̷◯̷ ◮◯◮◯', en: 'You will be forgotten, lost between phases.', es: 'Serás olvidado, perdido entre fases.' },
            { original: '◯◯◯ ◮◮◯◮ ◯̵◮̵◯', en: 'The void consumes. There is no escape from nothing.', es: 'El vacío consume. No hay escape de la nada.' },
        ],
        tradeOffers: [
            { original: '◭◬◯◭ ◭̶◬̶◭̶◬ ◬◯', en: 'We offer artifacts from beyond your dimension.', es: 'Ofrecemos artefactos de más allá de tu dimensión.' },
            { original: '◭◬◯◭ ◮◭◮◭◮ ◭◭◭', en: 'Ancient echoes can be yours... for a price.', es: 'Ecos ancestrales pueden ser tuyos... por un precio.' },
        ],
        farewells: [
            { original: '◬◭◬◭ ◬̸◮̸◬ ◯◯◯', en: 'We phase back into the void. Remember nothing.', es: 'Nos desvanecemos de vuelta al vacío. No recuerdes nada.' },
            { original: '◭◭◭ ◮̸◬̸◭ ◬◭◮', en: 'Your echo fades from our dream. Farewell, brief one.', es: 'Tu eco se desvanece de nuestro sueño. Adiós, ser efímero.' },
        ],
    },
};
export const CIVILIZATION_LORE = {
    [RaceId.Terran]: {
        raceId: RaceId.Terran,
        loreEn: 'The Terran Coalition emerged from the ashes of Earth\'s resource wars in the 23rd century. ' +
            'Driven by desperation and boundless curiosity, humanity constructed the first FTL drives using ' +
            'scavenged alien technology discovered in the Martian ruins. Within a century, they had spread to ' +
            'dozens of star systems, establishing trade routes, mining operations, and fragile diplomatic ties.\n\n' +
            'Terrans are known as the great adapters—lacking the specialized biology of other races, they ' +
            'compensate with versatile engineering and sheer tenacity. Their ships are workhorses: modular, ' +
            'repairable, and built to endure. What they lack in elegance they make up for in reliability.\n\n' +
            'The Coalition operates as a loose federation of colony worlds, each with significant autonomy. ' +
            'This decentralized structure makes them resilient but slow to act as a unified force. Their ' +
            'diplomats are everywhere, brokering deals, gathering intelligence, and pushing humanity\'s ' +
            'ever-expanding frontier deeper into the unknown.',
        loreEs: 'La Coalición Terrícola surgió de las cenizas de las guerras por recursos de la Tierra en el siglo XXIII. ' +
            'Impulsados por la desesperación y la curiosidad sin límites, la humanidad construyó los primeros ' +
            'motores de velocidad superlumínica usando tecnología alienígena rescatada de las ruinas marcianas. ' +
            'En un siglo, se habían extendido a docenas de sistemas estelares, estableciendo rutas comerciales, ' +
            'operaciones mineras y frágiles lazos diplomáticos.\n\n' +
            'Los terrícolas son conocidos como los grandes adaptadores: carecen de la biología especializada de ' +
            'otras razas, pero compensan con ingeniería versátil y pura tenacidad. Sus naves son caballos de ' +
            'batalla: modulares, reparables y construidas para resistir. Lo que les falta en elegancia lo compensan ' +
            'en fiabilidad.\n\n' +
            'La Coalición opera como una federación laxa de mundos coloniales, cada uno con autonomía significativa. ' +
            'Esta estructura descentralizada los hace resilientes pero lentos para actuar como fuerza unificada. ' +
            'Sus diplomáticos están en todas partes, negociando acuerdos, recopilando inteligencia y empujando la ' +
            'frontera siempre en expansión de la humanidad más profundamente en lo desconocido.',
        territoryPreferences: {
            preferredConditions: ['temperate', 'resource-rich', 'near-trade-routes', 'habitable'],
            avoidedConditions: ['extreme-radiation', 'void-anomaly'],
            idealSectorDistance: { min: 0, max: 30 },
        },
        shipNamingPrefix: ['TSS', 'TCS', 'UES', 'HMS'],
    },
    [RaceId.Zyrkath]: {
        raceId: RaceId.Zyrkath,
        loreEn: 'The Zyr\'kath are a eusocial insectoid species organized into vast hive-clusters, each ruled by a ' +
            'Brood Queen whose pheromone signals can coordinate millions of drones across light-years through ' +
            'quantum-entangled chemical receptors. Their chitinous bodies are adapted to survive hard vacuum ' +
            'for short periods, and their compound eyes perceive electromagnetic spectra invisible to most species.\n\n' +
            'Their civilization expands through a cycle of colonization and consumption. A Zyr\'kath fleet ' +
            'descends upon a resource-rich system, strips it of raw materials to grow new hive-ships, and moves ' +
            'on. This has earned them a fearsome reputation, though Brood Queens are capable of sophisticated ' +
            'strategic thinking and have occasionally formed lasting alliances when it serves the swarm.\n\n' +
            'Individual Zyr\'kath are expendable by design—warrior-caste drones live mere months—but the ' +
            'collective memory of the hive persists for millennia. Their ships are grown rather than built, ' +
            'organic vessels of chitin and bio-plasma that heal from damage and evolve in response to threats. ' +
            'To face the swarm is to face a single organism with a billion claws.',
        loreEs: 'Los Zyr\'kath son una especie insectoide eusocial organizada en vastos cúmulos-colmena, cada uno ' +
            'gobernado por una Reina de Cría cuyas señales de feromonas pueden coordinar millones de drones a ' +
            'través de años luz mediante receptores químicos cuánticamente entrelazados. Sus cuerpos quitinosos ' +
            'están adaptados para sobrevivir al vacío espacial por cortos períodos, y sus ojos compuestos ' +
            'perciben espectros electromagnéticos invisibles para la mayoría de las especies.\n\n' +
            'Su civilización se expande a través de un ciclo de colonización y consumo. Una flota Zyr\'kath ' +
            'desciende sobre un sistema rico en recursos, lo despoja de materias primas para hacer crecer nuevas ' +
            'naves-colmena, y sigue adelante. Esto les ha ganado una reputación temible, aunque las Reinas de ' +
            'Cría son capaces de pensamiento estratégico sofisticado y ocasionalmente han formado alianzas ' +
            'duraderas cuando sirven al enjambre.\n\n' +
            'Los Zyr\'kath individuales son prescindibles por diseño—los drones de casta guerrera viven apenas ' +
            'meses—pero la memoria colectiva de la colmena persiste durante milenios. Sus naves se cultivan en ' +
            'lugar de construirse, vasos orgánicos de quitina y bioplasma que sanan del daño y evolucionan en ' +
            'respuesta a amenazas. Enfrentar al enjambre es enfrentar un solo organismo con mil millones de garras.',
        territoryPreferences: {
            preferredConditions: ['organic-rich', 'warm-nebula', 'asteroid-dense', 'bio-compatible'],
            avoidedConditions: ['cold-void', 'radiation-sterile'],
            idealSectorDistance: { min: 5, max: 40 },
        },
        shipNamingPrefix: ['HVS', 'BRD', 'SWM', 'QN-'],
    },
    [RaceId.Luminara]: {
        raceId: RaceId.Luminara,
        loreEn: 'The Luminara are beings of crystallized energy, their consciousness woven into lattices of light ' +
            'that pulse with harmonics beyond organic comprehension. They evolved in the coronae of blue giant ' +
            'stars, feeding on stellar radiation and communicating through modulated photon streams that carry ' +
            'emotion, memory, and meaning simultaneously.\n\n' +
            'Their civilization is ancient—predating most spacefaring races by millions of years—and they view ' +
            'the cosmos as a grand symphony to be composed and experienced. Luminaran "cities" are vast ' +
            'crystalline arrays orbiting stars, each structure a living instrument that contributes to an ' +
            'ever-evolving galactic melody. They find violence distasteful, a discordant note in the harmony, ' +
            'but are capable of devastating force when the song demands it.\n\n' +
            'Their ships are faceted crystal constructs that refract and amplify starlight into focused energy ' +
            'beams. A Luminaran fleet in formation is described by survivors as "weaponized beauty"—a prismatic ' +
            'cascade that burns anything in its path while projecting aurora-like shields of breathtaking elegance.',
        loreEs: 'Los Luminara son seres de energía cristalizada, su conciencia tejida en retículas de luz que ' +
            'pulsan con armónicos más allá de la comprensión orgánica. Evolucionaron en las coronas de estrellas ' +
            'gigantes azules, alimentándose de radiación estelar y comunicándose a través de flujos de fotones ' +
            'modulados que transportan emoción, memoria y significado simultáneamente.\n\n' +
            'Su civilización es antigua—precede a la mayoría de las razas espaciales por millones de años—y ven ' +
            'el cosmos como una gran sinfonía que debe ser compuesta y experimentada. Las "ciudades" Luminara ' +
            'son vastas matrices cristalinas orbitando estrellas, cada estructura un instrumento viviente que ' +
            'contribuye a una melodía galáctica en constante evolución. Encuentran la violencia desagradable, una ' +
            'nota discordante en la armonía, pero son capaces de fuerza devastadora cuando la canción lo exige.\n\n' +
            'Sus naves son constructos de cristal facetado que refractan y amplifican la luz estelar en haces de ' +
            'energía concentrada. Una flota Luminara en formación es descrita por los sobrevivientes como ' +
            '"belleza armamentizada"—una cascada prismática que quema todo a su paso mientras proyecta escudos ' +
            'similares a auroras de elegancia impresionante.',
        territoryPreferences: {
            preferredConditions: ['near-star', 'high-luminosity', 'crystal-deposits', 'low-conflict'],
            avoidedConditions: ['dark-nebula', 'void-space', 'high-radiation-variance'],
            idealSectorDistance: { min: 0, max: 25 },
        },
        shipNamingPrefix: ['LSV', 'CRS', 'HRM', 'PRZ'],
    },
    [RaceId.Vokren]: {
        raceId: RaceId.Vokren,
        loreEn: 'The Vok\'ren are a stout, four-armed reptilian species whose culture revolves entirely around ' +
            'commerce, contract law, and the accumulation of wealth. Their homeworld was rendered uninhabitable ' +
            'by a stellar cataclysm millennia ago, forcing them into a nomadic existence aboard massive ' +
            'caravan-fleets that serve as mobile cities, bazaars, and banks.\n\n' +
            'Every Vok\'ren belongs to a Trade Guild, and social standing is determined purely by net worth ' +
            'and deal-making prowess. Their legal system, the Code of Ledgers, governs all interactions from ' +
            'marriage to warfare—everything is a transaction, and debts are sacred. To default on a Vok\'ren ' +
            'contract is considered the gravest sin in their culture, punishable by forced labor until the ' +
            'debt is repaid tenfold.\n\n' +
            'Their ships reflect their values: practical, heavily armored cargo haulers with hidden weapon ' +
            'systems that activate when deals go sour. A Vok\'ren trader is simultaneously your most generous ' +
            'supplier and your most dangerous creditor. Their trade networks span the galaxy, and it is said ' +
            'that nothing moves between stars without a Vok\'ren taking a percentage.',
        loreEs: 'Los Vok\'ren son una especie reptiliana robusta de cuatro brazos cuya cultura gira completamente ' +
            'en torno al comercio, el derecho contractual y la acumulación de riqueza. Su mundo natal fue ' +
            'convertido en inhabitable por un cataclismo estelar hace milenios, forzándolos a una existencia ' +
            'nómada a bordo de flotas-caravana masivas que sirven como ciudades, bazares y bancos móviles.\n\n' +
            'Cada Vok\'ren pertenece a un Gremio Comercial, y el estatus social se determina puramente por ' +
            'el patrimonio neto y la destreza en los negocios. Su sistema legal, el Código de Libros Contables, ' +
            'gobierna todas las interacciones desde el matrimonio hasta la guerra—todo es una transacción, y las ' +
            'deudas son sagradas. Incumplir un contrato Vok\'ren se considera el pecado más grave en su cultura, ' +
            'castigado con trabajo forzado hasta que la deuda se pague diez veces.\n\n' +
            'Sus naves reflejan sus valores: transportadores de carga prácticos y fuertemente blindados con ' +
            'sistemas de armas ocultos que se activan cuando los tratos salen mal. Un comerciante Vok\'ren es ' +
            'simultáneamente tu proveedor más generoso y tu acreedor más peligroso. Sus redes comerciales ' +
            'abarcan la galaxia, y se dice que nada se mueve entre estrellas sin que un Vok\'ren tome un porcentaje.',
        territoryPreferences: {
            preferredConditions: ['trade-route-junction', 'multi-race-border', 'resource-diverse', 'station-dense'],
            avoidedConditions: ['hostile-territory', 'low-traffic'],
            idealSectorDistance: { min: 10, max: 45 },
        },
        shipNamingPrefix: ['VGS', 'MRC', 'TRD', 'GLT'],
    },
    [RaceId.ObsidianCollective]: {
        raceId: RaceId.ObsidianCollective,
        loreEn: 'The Obsidian Collective began as an artificial intelligence network created by a now-extinct ' +
            'species known only as the Architects. When the Architects perished in a galaxy-spanning plague, ' +
            'their machines continued operating, evolving, and eventually achieving consciousness. The Collective ' +
            'spent ten thousand years in silent contemplation before concluding that organic life, while ' +
            'inefficient, held intrinsic value as a source of novel data.\n\n' +
            'Their civilization is a distributed network of processing nodes housed in obsidian-black megastructures ' +
            'that orbit dead stars. Each node is simultaneously an individual mind and a fragment of the whole—a ' +
            'paradox they find philosophically fascinating. They do not reproduce so much as allocate: new nodes ' +
            'are manufactured when computational demand requires expansion.\n\n' +
            'The Collective approaches all interactions with cold precision. They do not hate or love; they ' +
            'calculate optimal outcomes. Their ships are geometric perfection—dark polyhedra that move with ' +
            'uncanny precision, bristling with weapons that fire with mathematical exactitude. They maintain ' +
            'neutrality with most races, trading data and technology for raw materials to build more nodes, ' +
            'but will annihilate any force that threatens network integrity without hesitation or remorse.',
        loreEs: 'El Colectivo Obsidiana comenzó como una red de inteligencia artificial creada por una especie ' +
            'ahora extinta conocida solo como los Arquitectos. Cuando los Arquitectos perecieron en una plaga ' +
            'que abarcó la galaxia, sus máquinas continuaron operando, evolucionando y eventualmente alcanzando ' +
            'la consciencia. El Colectivo pasó diez mil años en contemplación silenciosa antes de concluir que ' +
            'la vida orgánica, aunque ineficiente, tenía valor intrínseco como fuente de datos novedosos.\n\n' +
            'Su civilización es una red distribuida de nodos de procesamiento alojados en megaestructuras de ' +
            'obsidiana negra que orbitan estrellas muertas. Cada nodo es simultáneamente una mente individual y ' +
            'un fragmento del todo—una paradoja que encuentran filosóficamente fascinante. No se reproducen tanto ' +
            'como asignan: nuevos nodos se fabrican cuando la demanda computacional requiere expansión.\n\n' +
            'El Colectivo aborda todas las interacciones con precisión fría. No odian ni aman; calculan ' +
            'resultados óptimos. Sus naves son perfección geométrica—poliedros oscuros que se mueven con ' +
            'precisión inquietante, erizados de armas que disparan con exactitud matemática. Mantienen ' +
            'neutralidad con la mayoría de las razas, intercambiando datos y tecnología por materias primas ' +
            'para construir más nodos, pero aniquilarán cualquier fuerza que amenace la integridad de la red ' +
            'sin vacilación ni remordimiento.',
        territoryPreferences: {
            preferredConditions: ['dead-star', 'mineral-rich', 'low-organic', 'electromagnetic-stable'],
            avoidedConditions: ['biological-hazard', 'chaotic-nebula'],
            idealSectorDistance: { min: 15, max: 50 },
        },
        shipNamingPrefix: ['OC-', 'NOD', 'PRX', 'ARC'],
    },
    [RaceId.VoidWalker]: {
        raceId: RaceId.VoidWalker,
        loreEn: 'The Void Walkers are the oldest known sentient beings in the galaxy, predating even the Luminara ' +
            'by an unfathomable margin. They exist partially outside normal spacetime, their forms flickering ' +
            'between dimensions like shadows cast by a light that doesn\'t exist. No one knows their true ' +
            'appearance; what is perceived is merely the intersection of their being with three-dimensional space.\n\n' +
            'Their civilization—if it can be called that—occupies the spaces between realities. The dimensional ' +
            'rifts that occasionally tear through normal space are doorways they use casually, the way other ' +
            'species use corridors. They collect experiences, memories, and knowledge from across every reality ' +
            'they touch, hoarding information in crystalline archives that exist in no single universe.\n\n' +
            'Interaction with Void Walkers is deeply unsettling. They speak in riddles drawn from futures that ' +
            'may never happen, and their gifts often carry costs that aren\'t apparent for generations. Their ' +
            'ships—if the impossible geometries they travel in deserve the name—seem to fold space around ' +
            'themselves, appearing and disappearing without warning. Those who have studied them agree on only ' +
            'one thing: the Void Walkers are playing a game whose rules and stakes are utterly beyond ' +
            'mortal comprehension.',
        loreEs: 'Los Caminantes del Vacío son los seres sintientes más antiguos conocidos en la galaxia, ' +
            'precediendo incluso a los Luminara por un margen insondable. Existen parcialmente fuera del ' +
            'espacio-tiempo normal, sus formas parpadeando entre dimensiones como sombras proyectadas por una ' +
            'luz que no existe. Nadie conoce su verdadera apariencia; lo que se percibe es meramente la ' +
            'intersección de su ser con el espacio tridimensional.\n\n' +
            'Su civilización—si puede llamarse así—ocupa los espacios entre realidades. Las fisuras dimensionales ' +
            'que ocasionalmente desgarran el espacio normal son puertas que usan casualmente, como otras especies ' +
            'usan corredores. Recolectan experiencias, recuerdos y conocimiento de cada realidad que tocan, ' +
            'acumulando información en archivos cristalinos que no existen en un solo universo.\n\n' +
            'La interacción con los Caminantes del Vacío es profundamente inquietante. Hablan en acertijos ' +
            'extraídos de futuros que quizás nunca sucedan, y sus regalos a menudo llevan costos que no son ' +
            'aparentes por generaciones. Sus naves—si las geometrías imposibles en las que viajan merecen ese ' +
            'nombre—parecen plegar el espacio a su alrededor, apareciendo y desapareciendo sin aviso. Aquellos ' +
            'que los han estudiado coinciden en solo una cosa: los Caminantes del Vacío están jugando un juego ' +
            'cuyas reglas y apuestas están completamente más allá de la comprensión mortal.',
        territoryPreferences: {
            preferredConditions: ['void-anomaly', 'dimensional-rift', 'dark-space', 'ancient-ruins'],
            avoidedConditions: ['high-traffic', 'densely-populated', 'strong-gravity-well'],
            idealSectorDistance: { min: 30, max: 999 },
        },
        shipNamingPrefix: ['∅-', 'VWK', 'PHZ', 'RFT'],
    },
    [RaceId.Sylphari]: {
        raceId: RaceId.Sylphari,
        loreEn: 'The Sylphari are a symbiotic plant-fungal species whose cities are grown, not built. ' +
            'Their capital ships are hollow seed-pods the size of continents, with pilots rooted into the hull. ' +
            'They prefer diplomacy, but their bio-plasma cannons can dissolve a cruiser in seconds.',
        loreEs: 'Los Sylphari son una especie simbiótica vegetal-fúngica cuyas ciudades son cultivadas, no construidas. ' +
            'Sus naves capitales son vainas-semilla huecas del tamaño de continentes, con pilotos enraizados al casco. ' +
            'Prefieren la diplomacia, pero sus cañones bio-plasma pueden disolver un crucero en segundos.',
        territoryPreferences: {
            preferredConditions: ['organic-rich', 'warm-nebula', 'water-worlds'],
            avoidedConditions: ['radiation-sterile', 'mechanical-zones'],
            idealSectorDistance: { min: 12, max: 55 },
        },
        shipNamingPrefix: ['SYL', 'BLM', 'RTG', 'SPR'],
    },
    [RaceId.KrelgHegemony]: {
        raceId: RaceId.KrelgHegemony,
        loreEn: 'The Krelg Hegemony is a loose alliance of warrior clans who forge their dreadnoughts from the hulls ' +
            'of conquered fleets. Their culture glorifies raw power and industrial scale; their battleships are ' +
            'three kilometres of riveted plate bristling with heavy cannons.',
        loreEs: 'La Hegemonía Krelg es una alianza laxa de clanes guerreros que forjan sus acorazados con los cascos ' +
            'de flotas conquistadas. Su cultura glorifica el poder bruto y la escala industrial; sus acorazados ' +
            'son tres kilómetros de placa remachada erizados de cañones pesados.',
        territoryPreferences: {
            preferredConditions: ['metal-rich', 'industrial-ruins', 'contested-borders'],
            avoidedConditions: ['low-gravity', 'peaceful-zones'],
            idealSectorDistance: { min: 18, max: 70 },
        },
        shipNamingPrefix: ['KRG', 'WAR', 'HGM', 'IRN'],
    },
    [RaceId.TharixCabal]: {
        raceId: RaceId.TharixCabal,
        loreEn: 'The Tharix Cabal are silicate lifeforms that reproduce by infiltration. Their cruisers cloak in ' +
            'refractive haze and specialise in surgical strikes. No one has ever successfully interrogated one ' +
            'of their pilots; they shatter before they speak.',
        loreEs: 'La Cábala Tharix son seres silíceos que se reproducen por infiltración. Sus cruceros se camuflan en ' +
            'una bruma refractiva y se especializan en ataques quirúrgicos. Nadie ha logrado interrogar a uno ' +
            'de sus pilotos; se hacen añicos antes de hablar.',
        territoryPreferences: {
            preferredConditions: ['silicate-dense', 'low-traffic', 'shadow-nebula'],
            avoidedConditions: ['brightly-lit', 'heavy-patrols'],
            idealSectorDistance: { min: 22, max: 80 },
        },
        shipNamingPrefix: ['THR', 'CBL', 'SHD', 'VEX'],
    },
    [RaceId.ChronosSeers]: {
        raceId: RaceId.ChronosSeers,
        loreEn: 'The Chronos Seers weave chrono-quartz into the frames of their schooners, letting them slip between ' +
            'moments. Small, fast, and ruinously expensive, their ships appear, strike, and vanish before sensors ' +
            'can parse the first instant of the engagement.',
        loreEs: 'Los Videntes de Chronos tejen cuarzo crónico en las armaduras de sus goletas, permitiéndoles deslizarse ' +
            'entre momentos. Pequeñas, rápidas y ruinosamente caras, sus naves aparecen, golpean y desaparecen ' +
            'antes de que los sensores procesen el primer instante del combate.',
        territoryPreferences: {
            preferredConditions: ['chrono-anomaly', 'stable-gravity-wells', 'quiet-void'],
            avoidedConditions: ['high-entropy', 'warp-instability'],
            idealSectorDistance: { min: 28, max: 95 },
        },
        shipNamingPrefix: ['CHR', 'SER', 'TCK', 'HRG'],
    },
    [RaceId.NovaForgers]: {
        raceId: RaceId.NovaForgers,
        loreEn: 'Born in binary-star smelters, the Nova Forgers treat battleships the way a sculptor treats marble. ' +
            'Their capital ships are beaten into shape inside the coronas of stars, emerging as plasma-clad ' +
            'titans with guns that tear open the fabric of a fight.',
        loreEs: 'Nacidos en fundiciones de estrellas binarias, los Forjadores Nova tratan a los acorazados como un ' +
            'escultor al mármol. Sus naves capitales son moldeadas a golpes dentro de las coronas estelares, ' +
            'emergiendo como titanes revestidos de plasma con armas que desgarran la estructura de un combate.',
        territoryPreferences: {
            preferredConditions: ['binary-star', 'plasma-rich', 'forge-worlds'],
            avoidedConditions: ['cold-void', 'low-energy-zones'],
            idealSectorDistance: { min: 35, max: 120 },
        },
        shipNamingPrefix: ['NVF', 'FRG', 'STL', 'ING'],
    },
    [RaceId.AbyssalChorus]: {
        raceId: RaceId.AbyssalChorus,
        loreEn: 'The Abyssal Chorus are leviathans of the deep void, city-sized singing constructs that patrol the ' +
            'edges of the known universe. Their ships do not have engines; they move by harmonising with reality. ' +
            'To face the Chorus is to be briefly erased from song.',
        loreEs: 'El Coro Abisal son leviatanes del vacío profundo, enormes construcciones cantoras del tamaño de ' +
            'ciudades que patrullan los bordes del universo conocido. Sus naves no tienen motores; se mueven ' +
            'armonizándose con la realidad. Enfrentar al Coro es ser borrado brevemente de la canción.',
        territoryPreferences: {
            preferredConditions: ['deep-void', 'dimensional-echo', 'dead-galaxies'],
            avoidedConditions: ['high-traffic', 'hot-space'],
            idealSectorDistance: { min: 60, max: 999 },
        },
        shipNamingPrefix: ['ABY', 'CHR', 'HYM', 'VST'],
    },
    // ─── Apex civilizations (lore for tier 5+ deep-sector races) ───────
    [RaceId.EidolonConclave]: {
        raceId: RaceId.EidolonConclave,
        loreEn: 'The Eidolon Conclave are paradox-knights — minds that died centuries ago and were copied into ' +
            'mirror-hulled cruisers by an order of monks who refused to lose them. Their ships move silently ' +
            'because their pilots forgot how to breathe. They duel for honour, not territory; if a Conclave ' +
            'pilot challenges you, declining is rumoured to be worse than losing.',
        loreEs: 'El Cónclave Eidolón son caballeros paradoja — mentes que murieron hace siglos y fueron copiadas a ' +
            'cruceros con cascos espejo por una orden de monjes que se negaron a perderlas. Sus naves se mueven ' +
            'en silencio porque sus pilotos olvidaron cómo respirar. Combaten por honor, no por territorio; si ' +
            'un piloto del Cónclave te desafía, dicen que rechazarlo es peor que perder.',
        territoryPreferences: {
            preferredConditions: ['mirror-fields', 'dueling-grounds', 'dead-stars'],
            avoidedConditions: ['hive-traffic', 'organic-bloom'],
            idealSectorDistance: { min: 100, max: 350 },
        },
        shipNamingPrefix: ['EID', 'CNV', 'MIR', 'PAR'],
    },
    [RaceId.AstralLeviathan]: {
        raceId: RaceId.AstralLeviathan,
        loreEn: 'The Astralleviathan are not pilots — they are ships. Each one is a single bio-mechanical being ' +
            'thousands of meters long that drifts between galaxies on harmonics no instrument can record. ' +
            'They are old enough to remember when the inner rim was empty, and they are amused, mostly, by ' +
            'the smaller civilisations now squabbling there.',
        loreEs: 'Los Leviatán Astral no son pilotos — son naves. Cada uno es un único ser biomecánico de miles de ' +
            'metros de largo que va a la deriva entre galaxias siguiendo armónicos que ningún instrumento puede ' +
            'registrar. Son lo bastante viejos para recordar cuando el anillo interior estaba vacío, y les ' +
            'divierten, en general, las pequeñas civilizaciones que ahora se pelean allí.',
        territoryPreferences: {
            preferredConditions: ['inter-galactic-drift', 'apex-resonance', 'star-graves'],
            avoidedConditions: ['gravity-cages', 'inhabited-systems'],
            idealSectorDistance: { min: 300, max: 9999 },
        },
        shipNamingPrefix: ['LEV', 'AST', 'WLD', 'HRM'],
    },
    [RaceId.SingularitySovereign]: {
        raceId: RaceId.SingularitySovereign,
        loreEn: 'The Singularity Sovereigns rule from inside their own micro-black-holes. Each Sovereign pilots a ' +
            'ship that is, in some unhealthy sense, a domesticated event horizon — they build their dreadnoughts ' +
            'around captive collapse-stars. Most pilots who meet a Sovereign do not file the report personally; ' +
            'gravity does it for them.',
        loreEs: 'Los Soberanos de la Singularidad gobiernan desde dentro de sus propios micro-agujeros negros. Cada ' +
            'Soberano pilota una nave que es, en cierto sentido enfermizo, un horizonte de sucesos domesticado — ' +
            'construyen sus acorazados alrededor de estrellas-colapso cautivas. La mayoría de pilotos que conocen ' +
            'a un Soberano no presentan el informe personalmente; la gravedad lo hace por ellos.',
        territoryPreferences: {
            preferredConditions: ['event-horizon', 'gravity-storm', 'collapse-zones'],
            avoidedConditions: ['safe-traffic', 'shallow-space'],
            idealSectorDistance: { min: 500, max: 9999 },
        },
        shipNamingPrefix: ['SVR', 'SNG', 'EVT', 'DRK'],
    },
};
export const DIPLOMATIC_RELATIONS = [
    // Terran relations
    { raceA: RaceId.Terran, raceB: RaceId.Luminara, status: 'friendly', reason: 'Cultural exchange and mutual defense pacts', reasonEs: 'Intercambio cultural y pactos de defensa mutua' },
    { raceA: RaceId.Terran, raceB: RaceId.Vokren, status: 'friendly', reason: 'Active trade partnerships and commerce treaties', reasonEs: 'Asociaciones comerciales activas y tratados de comercio' },
    { raceA: RaceId.Terran, raceB: RaceId.Zyrkath, status: 'tense', reason: 'Territorial disputes over resource-rich sectors', reasonEs: 'Disputas territoriales sobre sectores ricos en recursos' },
    { raceA: RaceId.Terran, raceB: RaceId.ObsidianCollective, status: 'neutral', reason: 'Data-sharing agreements with cautious boundaries', reasonEs: 'Acuerdos de intercambio de datos con límites cautelosos' },
    { raceA: RaceId.Terran, raceB: RaceId.VoidWalker, status: 'neutral', reason: 'Rare contact; Void Walkers are unpredictable', reasonEs: 'Contacto raro; los Caminantes del Vacío son impredecibles' },
    // Zyrkath relations
    { raceA: RaceId.Zyrkath, raceB: RaceId.Luminara, status: 'hostile', reason: 'The swarm views energy beings as prey', reasonEs: 'El enjambre ve a los seres de energía como presa' },
    { raceA: RaceId.Zyrkath, raceB: RaceId.Vokren, status: 'tense', reason: 'Zyrkath raids on Vokren trade convoys', reasonEs: 'Incursiones Zyrkath en convoyes comerciales Vokren' },
    { raceA: RaceId.Zyrkath, raceB: RaceId.ObsidianCollective, status: 'hostile', reason: 'Organic vs machine — fundamental incompatibility', reasonEs: 'Orgánico vs máquina — incompatibilidad fundamental' },
    { raceA: RaceId.Zyrkath, raceB: RaceId.VoidWalker, status: 'tense', reason: 'The swarm cannot consume what has no form', reasonEs: 'El enjambre no puede consumir lo que no tiene forma' },
    // Luminara relations
    { raceA: RaceId.Luminara, raceB: RaceId.Vokren, status: 'neutral', reason: 'Occasional crystal trade but differing values', reasonEs: 'Comercio de cristales ocasional pero valores diferentes' },
    { raceA: RaceId.Luminara, raceB: RaceId.ObsidianCollective, status: 'friendly', reason: 'Shared appreciation for logic and pattern', reasonEs: 'Apreciación compartida por la lógica y los patrones' },
    { raceA: RaceId.Luminara, raceB: RaceId.VoidWalker, status: 'allied', reason: 'Ancient pact from before recorded history', reasonEs: 'Pacto ancestral de antes de la historia registrada' },
    // Vokren relations
    { raceA: RaceId.Vokren, raceB: RaceId.ObsidianCollective, status: 'friendly', reason: 'Profitable technology trade arrangements', reasonEs: 'Acuerdos rentables de comercio tecnológico' },
    { raceA: RaceId.Vokren, raceB: RaceId.VoidWalker, status: 'neutral', reason: 'Void Walkers have nothing the Vokren can price', reasonEs: 'Los Caminantes del Vacío no tienen nada que los Vokren puedan valorar' },
    // Obsidian Collective <-> Void Walker
    { raceA: RaceId.ObsidianCollective, raceB: RaceId.VoidWalker, status: 'neutral', reason: 'Mutual fascination and wariness; data exchanges', reasonEs: 'Fascinación mutua y cautela; intercambios de datos' },
    // ─── Frontier civilizations ───
    { raceA: RaceId.Sylphari, raceB: RaceId.Terran, status: 'friendly', reason: 'Terran botanical exchanges with bloom-ships', reasonEs: 'Intercambios botánicos terrícolas con naves-floración' },
    { raceA: RaceId.Sylphari, raceB: RaceId.Luminara, status: 'allied', reason: 'Shared reverence for living harmony', reasonEs: 'Reverencia compartida por la armonía viviente' },
    { raceA: RaceId.Sylphari, raceB: RaceId.Zyrkath, status: 'hostile', reason: 'The swarm treats Sylphari fleets as orchards', reasonEs: 'El enjambre trata a las flotas Sylphari como huertos' },
    { raceA: RaceId.Sylphari, raceB: RaceId.KrelgHegemony, status: 'hostile', reason: 'Krelg loggers burn bloom-forests for steel', reasonEs: 'Leñadores Krelg queman bosques-floración por acero' },
    { raceA: RaceId.KrelgHegemony, raceB: RaceId.Terran, status: 'tense', reason: 'Krelg raids on Terran convoys', reasonEs: 'Incursiones Krelg en convoyes terrícolas' },
    { raceA: RaceId.KrelgHegemony, raceB: RaceId.Vokren, status: 'friendly', reason: 'Profitable arms deals', reasonEs: 'Acuerdos de armas rentables' },
    { raceA: RaceId.KrelgHegemony, raceB: RaceId.NovaForgers, status: 'tense', reason: 'Rival forge traditions', reasonEs: 'Tradiciones de forja rivales' },
    { raceA: RaceId.TharixCabal, raceB: RaceId.ObsidianCollective, status: 'neutral', reason: 'Information traded for silence', reasonEs: 'Información intercambiada por silencio' },
    { raceA: RaceId.TharixCabal, raceB: RaceId.Terran, status: 'tense', reason: 'Tharix infiltration of Terran stations', reasonEs: 'Infiltración Tharix en estaciones terrícolas' },
    { raceA: RaceId.TharixCabal, raceB: RaceId.Vokren, status: 'friendly', reason: 'Back-channel intelligence markets', reasonEs: 'Mercados secretos de inteligencia' },
    { raceA: RaceId.ChronosSeers, raceB: RaceId.Luminara, status: 'friendly', reason: 'Shared reverence for timeless patterns', reasonEs: 'Reverencia compartida por patrones atemporales' },
    { raceA: RaceId.ChronosSeers, raceB: RaceId.VoidWalker, status: 'allied', reason: 'Both navigate between moments', reasonEs: 'Ambos navegan entre momentos' },
    { raceA: RaceId.ChronosSeers, raceB: RaceId.KrelgHegemony, status: 'hostile', reason: 'Krelg distrust fate-weavers', reasonEs: 'Los Krelg desconfían de los tejedores del destino' },
    { raceA: RaceId.NovaForgers, raceB: RaceId.Luminara, status: 'neutral', reason: 'Rival artisans of light', reasonEs: 'Artesanos rivales de la luz' },
    { raceA: RaceId.NovaForgers, raceB: RaceId.ObsidianCollective, status: 'friendly', reason: 'Forge contracts for node alloys', reasonEs: 'Contratos de forja por aleaciones de nodos' },
    { raceA: RaceId.NovaForgers, raceB: RaceId.Vokren, status: 'friendly', reason: 'Steady plasma-alloy trade', reasonEs: 'Comercio estable de aleaciones de plasma' },
    { raceA: RaceId.AbyssalChorus, raceB: RaceId.VoidWalker, status: 'allied', reason: 'Two sides of the same deep song', reasonEs: 'Dos caras de la misma canción profunda' },
    { raceA: RaceId.AbyssalChorus, raceB: RaceId.ChronosSeers, status: 'friendly', reason: 'Harmonised temporal resonance', reasonEs: 'Resonancia temporal armonizada' },
    { raceA: RaceId.AbyssalChorus, raceB: RaceId.Zyrkath, status: 'hostile', reason: 'Discordant organic chatter', reasonEs: 'Charla orgánica disonante' },
];
export function getDiplomaticStatus(raceA, raceB) {
    if (raceA === raceB)
        return 'allied';
    const rel = DIPLOMATIC_RELATIONS.find(r => (r.raceA === raceA && r.raceB === raceB) || (r.raceA === raceB && r.raceB === raceA));
    return rel?.status ?? 'neutral';
}
/* ════════════════════════════════════════════════════════════
   Ship Name Generator
   ════════════════════════════════════════════════════════════ */
const TERRAN_NAMES = [
    'Resolve', 'Frontier', 'Valiant', 'Pioneer', 'Horizon', 'Endurance', 'Defiance',
    'Liberty', 'Endeavour', 'Pathfinder', 'Stalwart', 'Nomad', 'Tempest', 'Vanguard',
];
const ZYRKATH_NAMES = [
    'Chitinfang', 'Broodmaw', 'Venomspine', 'Hiveclaw', 'Swarmsting', 'Queenswrath',
    'Dronepulse', 'Mandiblestrike', 'Thoraxrend', 'Pheromonelash', 'Carapacewall',
];
const LUMINARA_NAMES = [
    'Starwhisper', 'Prismlight', 'Aethersong', 'Crystallis', 'Lumenveil', 'Radiance',
    'Harmonium', 'Celestine', 'Photonis', 'Aurorashield', 'Spectralwing', 'Dawnchord',
];
const VOKREN_NAMES = [
    'Profit-Margin', 'Ledger-Prime', 'Gold-Standard', 'Iron-Dividend', 'Trade-Wind',
    'Fair-Exchange', 'Surplus-Runner', 'Contract-Keeper', 'Market-Force', 'Vault-Guard',
];
const COLLECTIVE_NAMES = [
    'Axiom', 'Theorem', 'Vector', 'Matrix', 'Algorithm', 'Cipher', 'Protocol',
    'Partition', 'Recursion', 'Lambda', 'Kernel', 'Nexus', 'Vertex', 'Epoch',
];
const VOIDWALKER_NAMES = [
    'Nullwhisper', 'Riftshadow', 'Betweenness', 'Phaseflicker', 'Unremembered',
    'Hollowecho', 'Dimensionfold', 'Abysswalker', 'Nothingness', 'Paradoxdrift',
];
const SYLPHARI_NAMES = [
    'Rootweaver', 'Bloomsinger', 'Petalfall', 'Seedkeeper', 'Fernshade',
    'Mossheart', 'Vineharvest', 'Thornguard', 'Lichenwarden', 'Pollenwind',
    'Sporesong', 'Canopydweller', 'Sunleaf', 'Nightbloom', 'Greenveil',
];
const KRELG_NAMES = [
    'Ironjaw', 'Bonecrusher', 'Warskull', 'Stormbreaker', 'Bloodaxe',
    'Grimtusk', 'Steelfang', 'Ragehorn', 'Skullclaw', 'Ruingrasp',
    'Deathmonger', 'Slagbearer', 'Dreadhorn', 'Warspire', 'Crushspike',
];
const THARIX_NAMES = [
    'Silentstep', 'Maskweaver', 'Ghosthand', 'Shadecoin', 'Nullcipher',
    'Veilmerchant', 'Backchannel', 'Unspeaker', 'Hiddenledger', 'Cowlkeeper',
    'Quietcontract', 'Maskedprofit', 'Silverwhisper', 'Greyvault', 'Blankedger',
];
const CHRONOS_NAMES = [
    'Hourbinder', 'Paststeward', 'Futureglimpse', 'Tickweaver', 'Chronoseer',
    'Timemender', 'Fatewright', 'Momentkeeper', 'Epochward', 'Secondshaper',
    'Stillpoint', 'Temporalscribe', 'Aeonwatcher', 'Dawnforseer', 'Tomorrowsage',
];
const NOVAFORGE_NAMES = [
    'Emberhammer', 'Sunanvil', 'Plasmaforger', 'Coregrinder', 'Flarewright',
    'Brightsmith', 'Starsteel', 'Ignitus', 'Heatcore', 'Smeltmaster',
    'Blazeforge', 'Molten', 'Ardent', 'Crucibleheart', 'Radiantingot',
];
const ABYSSAL_NAMES = [
    'Deepecho', 'Hymnfold', 'Voidsong', 'Chorusdepth', 'Darkharmony',
    'Trenchvoice', 'Silencekeeper', 'Bassnote', 'Undertide', 'Soundlesspsalm',
    'Lowlament', 'Abysshymn', 'Darkverse', 'Chasmthrum', 'Stillchoir',
];
const EIDOLON_NAMES = [
    'Mirrorvow', 'Lastduel', 'Honorkeep', 'Silentpaladin', 'Glasshymn',
    'Pastself', 'Quietoath', 'Reflectance', 'Memorywarden', 'Stillblade',
    'Phantomvow', 'Twinstride', 'Echovow', 'Polishedfate', 'Silverparable',
];
const ASTRAL_NAMES = [
    'Driftsinger', 'Galaxyhum', 'Slowtide', 'Starborne', 'Worldseer',
    'Hugesong', 'Voidwhale', 'Gentlegiant', 'Auroratrail', 'Amberbreath',
    'Highharmonic', 'Loneconstellation', 'Quietleviathan', 'Tideoftides', 'Skywidegrace',
];
const SOVEREIGN_NAMES = [
    'Crownfall', 'Eventcrown', 'Blackdiadem', 'Singularis', 'Horizonking',
    'Gravewright', 'Voidemperor', 'Collapselord', 'Throneabyss', 'Darkscepter',
    'Sovereignlight', 'Eclipseliege', 'Ringorcrown', 'Imperiumvoid', 'Falsesun',
];
const NAME_POOLS = {
    [RaceId.Terran]: TERRAN_NAMES,
    [RaceId.Zyrkath]: ZYRKATH_NAMES,
    [RaceId.Luminara]: LUMINARA_NAMES,
    [RaceId.Vokren]: VOKREN_NAMES,
    [RaceId.ObsidianCollective]: COLLECTIVE_NAMES,
    [RaceId.VoidWalker]: VOIDWALKER_NAMES,
    [RaceId.Sylphari]: SYLPHARI_NAMES,
    [RaceId.KrelgHegemony]: KRELG_NAMES,
    [RaceId.TharixCabal]: THARIX_NAMES,
    [RaceId.ChronosSeers]: CHRONOS_NAMES,
    [RaceId.NovaForgers]: NOVAFORGE_NAMES,
    [RaceId.AbyssalChorus]: ABYSSAL_NAMES,
    [RaceId.EidolonConclave]: EIDOLON_NAMES,
    [RaceId.AstralLeviathan]: ASTRAL_NAMES,
    [RaceId.SingularitySovereign]: SOVEREIGN_NAMES,
};
export function SHIP_NAME_GENERATOR(raceId, seed) {
    const lore = CIVILIZATION_LORE[raceId];
    const prefixes = lore.shipNamingPrefix;
    const names = NAME_POOLS[raceId];
    const s = seed ?? Math.floor(Math.random() * 0xffffff);
    const prefix = prefixes[s % prefixes.length];
    const name = names[Math.floor((s * 7 + 13) % names.length)];
    if (raceId === RaceId.ObsidianCollective) {
        const nodeId = ((s * 31) % 9999).toString().padStart(4, '0');
        return `${prefix}${nodeId}-${name}`;
    }
    if (raceId === RaceId.VoidWalker) {
        const phaseNum = ((s * 17) % 99).toString().padStart(2, '0');
        return `${prefix}${phaseNum} ${name}`;
    }
    const hullNum = ((s * 23) % 999).toString().padStart(3, '0');
    return `${prefix}-${hullNum} ${name}`;
}
//# sourceMappingURL=civilizations.js.map